import React from "react";
import { IFormStyles, useFormStyles } from '../../..';
import Section from "../../../section/section";
import { StringHelper } from "../../../../utils/helpers";
import { SectionHeader } from "../../../section/components";

export interface FormSectionProps extends React.FormHTMLAttributes<HTMLFormElement> {
    title?: string
}

export const FormSection: React.FC<FormSectionProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    if ((props.children === null || props.children === undefined) && StringHelper.isNullOrEmpty(props.title)) {
        return (<SectionHeader style={styles.section.header} displayWhenEmpty={true} />);
    }

    return (
        <Section style={styles.section.container}>
            <Section.Header style={styles.section.header}>
                <Section.Title style={styles.section.headerTitle}>{props.title}</Section.Title>
            </Section.Header>
            <Section.Body style={styles.section.body}>
                {props.children}
            </Section.Body>
        </Section>
    );
};